import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { UserUrl } from '../../../shared/urls/user.url';
import { Page } from '../../../models/list/page.model';
import { FormLabelComponent } from '../../../components/form/label/label.component';

import { CashSaleModel, InvoiceModel, PartyType, InvoiceItemStatus, InvoiceItemType } from '../../../models/consultation/cash-sale.model';
import { PatientModel } from '../../../models/consultation/patient.model';
import { PayMethodPopupComponent } from './pay-method-popup.component';
import { CashSaleService } from './cash-sale.service';
import { InvoiceService, InvoiceList } from './invoice.service';
import { ProductPopupComponent } from './product-popup.component';
import { CreditNotePopupComponent } from './credit-note-popup.component';
import { ViewSchedulePopupComponent } from './view-schedule-popup.component';
import { NoteInvoicePopupComponent } from './note-invoice.popup.component';
import { ConsultationProcessService } from '../../consultation-process/consultation-process.service';
import { BaseConsultationComponent } from '../../consultation-process/base-consultation/base-consultation.component';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { ValidationService } from '../../../shared/services/validation.service';
import { ConfirmPayMethodPopupComponent } from './confirm-pay-method-popup.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
  selector: 'app-cash-sale',
  templateUrl: 'cash-sale.component.html',
  providers: [CashSaleService, InvoiceService, ConsultationProcessService]
})
export class CashSaleComponent extends BaseConsultationComponent
  implements OnInit {
  private reportTokenId: string;
  public partyType = PartyType;
  public invoiceInfoForm;
  public page = new Page();
  public appConstants = AppConstants;
  public invoiceItemStatus = InvoiceItemStatus;
  public invoiceItemType = InvoiceItemType;
  public dataRow = new Array<CashSaleModel>();
  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total // Footer total message
  };
  public patientDetail = new PatientModel();
  public discountData = [];
  public partyData = [];
  public currencyData = [];
  public feeData = [];
  public isCashSale = true;
  public invoiceData;
  public invoiceDate = new Date();
  public rate = 1; // rate is get base on selectedCurrency and default currency
  public organizationData = [];
  public isFromHistory: string;
  public isActiveOrganization = false;
  public organizationDiscountId: string;
  public note: string;
  public cashSaleInfo: any;
  public editModeFeeData = 0; // in invoice edit mode, show this price instead of feeId
  public feeTax = 0; // when user change fee, save fee tax to calculate later
  // currency Model
  public selectedCurrency: any = {
    code: '',
    id: '',
    symbol: '',
    symbolPosition: 'L'
  };
  // price Model
  public priceModel = {
    sub: 0,
    tax: 0,
    total: 0,
    fee: 0
  };
  // Payment data
  public paymentData;
  public deInvoiceDate = new Date();
  constructor(
    private formBuilder: FormBuilder,
    public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    public utility: Utility,
    private cashSaleService: CashSaleService,
    private sharedService: SharedService
  ) {
    super(
      dialogService,
      consultationProcessService,
      router,
      activeRouter,
      ConsultationStep.InvoiceComplete
    );
    this.note = '';
    this.createForm();
    // get menu toggle action from shareService
    this.menuSubscription = this.sharedService.getMenuToggle().subscribe(
      data => {
        this.updateTableLayout();
      });
    // get data entry service
    this.sharedService.getDataEntryUpdate().subscribe(
      data => {
        this.updateDataEntryMode(data);
      });
  }

  createForm() {
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0);
    this.invoiceInfoForm = this.formBuilder.group({
      invoiceDate: [currentDate, [Validators.required]],
      partyTypeId: ['', [Validators.required]],
      groupId: [null, [Validators.required]],
      orderNo: ''
    });
  }

  ngOnInit() {
    this.isDataEntryMode = this.isInDataEntryMode();
    this.reportTokenId = this.utility.randomKey();
    this.isFromHistory = this.activeRouter.snapshot.params['isFromHistory']
      ? this.activeRouter.snapshot.params['isFromHistory'].toLowerCase() : null;

      var editInvoice = this.activeRouter.snapshot.queryParams['editInvoice'] ? this.activeRouter.snapshot.queryParams['editInvoice'] : false;
    this.paymentData = {
      invoiceId:
        this.activeRouter.snapshot.queryParams['invoiceId'] == null
          ? ''
          : this.activeRouter.snapshot.queryParams['invoiceId'],
      isPayment:
        this.activeRouter.snapshot.queryParams['isPayment'] == null
          ? false
          : this.activeRouter.snapshot.queryParams['isPayment']
    };
    this.initDiscountData();
    this.initPartyTypeData(editInvoice);
    //  this.initCurrencyData();
    this.initPatientData();
    this.initFeeData();

  }

  initCashSaleData() {
    this.cashSaleService.getCashSalePatientData().subscribe(result => {
      if (result) {
        const data = result.json();
        this.patientDetail['patientREF'] = data['patientREF'];
        this.patientDetail['surName'] =
          data['firstName'] + ' ' + ['data.surName'];
        this.patientDetail['dateOfBirth'] = data['dateOfBirth'];
        this.patientDetail['partyTypeId'] = data.partyTypeId;
        if (data.partyTypeId === this.partyType.Individual) {
          this.isActiveOrganization = true;
        }
      }
    });
  }

  initPartyTypeData(isEdit) {
    this.cashSaleService.getPartyList().subscribe(result => {
      if (result) {
        let parties = [];
        result.json().forEach(element => {
          if (element["name"] !== "Family") {
            parties.push(element);
          }
        });
        //this.partyData = result.json();
        this.partyData = parties;
      }
    });
    this.cashSaleService.getInvoiceOrganization(isEdit).subscribe(result => {
      if (result) {
        const orgs = result.json();
        this.organizationData = result.json();
        this.organizationData.forEach(element => {
          if (element.isActive === false) {
            element.name = '(Inactive) ' + element.name;
          }
        });
      }
    });
  }

  initDiscountData() {
    this.cashSaleService.getDiscountList().subscribe(result => {
      if (result) {
        this.discountData = result.json();
        this.setPage({ offset: 0 });
      }
    });
    // this.discountData = this.cashSaleService.getDiscountList();
  }

  initPatientData() {
    // get patient details cashsale
    if (this.filterParam.patientId !== '' && this.filterParam.patientId !== undefined) {
      this.consultationProcessService
        .getPatientData(this.filterParam.patientId)
        .subscribe(result => {
          if (result) {
            this.patientDetail = result.json();
            this.isCashSale = false;
          }
        });
    } else if (!this.paymentData.isPayment) {
      this.disableParty(true);
      this.initCashSaleData();
    }
  }

  initFeeData() {
    this.cashSaleService.getConsultationFeeData().subscribe(result => {
      if (result) {
        const data = result.json();
        if (data.length > 0) {
          this.feeData = data;
          /*   if (this.invoiceData && this.invoiceData.hasOwnProperty('feeId')) {
                              // update selectedFee
                              const fee = this.feeData.filter(f => f.id === this.invoiceData.feeId);
                              if (fee.length > 0) {
                                  this.selectedFee = fee[0];
                              }
                          } */
          this.updateFeeData();
        }
      }
    });
  }

  /**
	* Populate the table with new data based on the page number
	* @param page The page to select
	*/
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    // call API and update data
    this.cashSaleService.getPatientInvoiceData(this.filterParam.id, this.isFromHistory, this.paymentData.invoiceId).subscribe(
      (result) => {
        if (result) {
          this.invoiceData = result.json();
          // update selected currency
          this.currencyData = this.invoiceData.currencyRate;
          this.updateSelectedCurrency(this.invoiceData.currencyCode);
          // get rate
          this.rate = this.getRate();
          if (this.invoiceData.invoiceDetails) {
            // add calculated price to invoice item
            this.invoiceData.invoiceDetails.forEach(i => {
              this.updateInvoiceItem(i);
            });
            this.dataRow = this.invoiceData.invoiceDetails;
            this.page.totalElements = this.dataRow.length;
          }
          // update this.organizationDiscountId
          if (this.invoiceData) {
            if (this.invoiceData.hasOwnProperty('organizationDiscountId')) {
              this.organizationDiscountId = this.invoiceData['organizationDiscountId'];
            }
            // if (this.invoiceData.hasOwnProperty('isCashSalePatient')) {
            //   this.disableParty(this.invoiceData['isCashSalePatient']);
            // }
            if (this.invoiceData.hasOwnProperty('feeTax')) {
              this.feeTax = this.invoiceData['feeTax'];
            }
            // if (this.isDataEntryMode && this.invoiceData.hasOwnProperty('date')) {

            //   this.invoiceInfoForm.controls['invoiceDate'].setValue(new Date(this.invoiceData.date));
            // }
            this.invoiceInfoForm.controls['invoiceDate'].setValue(new Date(this.invoiceData.date));
          }

          // update fee data
          this.updateFeeData();

          this.updatePriceModel();
          // update require field of invoiceInfoForm
          if (this.invoiceData.partyTypeId === this.partyType.Individual) {
            ValidationService.removeRequired(
              this.invoiceInfoForm.controls['groupId'],
              []
            );
          }

          this.cashSaleInfo = {
            orderNo: this.invoiceData.orderNo,
            partyTypeId: this.invoiceData.partyTypeId,
            groupId: this.invoiceData.groupId,
            invoiceDate: this.invoiceData.date,
          };
        }
      });
  }

  /**
     * convert fee value to selected curency
     */
  updateFeeData() {
    if (this.invoiceData && this.invoiceData.hasOwnProperty('feePrice') && (this.isFromHistory === 'edit' || this.paymentData.isPayment)) {
      this.editModeFeeData = this.roundPriceNumber(this.invoiceData['feePrice'] * this.rate);
    }
    this.feeData.forEach(f => {
      f['reValue'] = this.roundPriceNumber(f['value'] * this.rate);
    });
    if (this.invoiceData && this.invoiceData.hasOwnProperty('feeId')) {
      const fee = this.feeData.filter(f => f.id === this.invoiceData['feeId']);
      if (fee.length > 0) {
        this.priceModel.fee = fee[0].value * this.rate;
      }
    }
  }

  updateInvoiceItem(item) {
    if(item["discountPercent"] > 0)
    {
      const discountObj = this.getDiscountObject(item['discountId']);
      item['discountId'] = discountObj.id;
      item['discountPercent'] = discountObj.value;
      item['rePrice'] = this.roundPriceNumber(
        item['price'] * (1 - discountObj.value) * this.rate
      );
      item['reTax'] = this.roundPriceNumber(item['tax'] * (1 - discountObj.value) * this.rate);
    }
    else
    {
      item['reTax'] = this.roundPriceNumber(item['tax'] * (1 - item["discountValue"]/item['price']) * this.rate);
      item["rePrice"] = this.roundPriceNumber(
        (item["price"] - item["discountValue"]) * this.rate
      );
    }

  }

  updateAddedInvoiceItem(item) {
    var discountObj = null;
    if(this.organizationDiscountId != null )
    {
      discountObj = this.getDiscountObject(this.organizationDiscountId);
    }
    else
    {
      discountObj = this.getDiscountObject(item['discountId'])
    }
    item['discountId'] = discountObj.id;
    item['discountPercent'] = discountObj.value;
    item['rePrice'] = this.roundPriceNumber(
      item['price'] * (1 - discountObj.value) * this.rate
    );
    item['reTax'] = this.roundPriceNumber(item['tax'] * (1 - discountObj.value) * this.rate);
  }

  /**
	 * update selectedCurrency model when user change currency
	 * @param currencyId String : currency Id that user selected in Currency select box
	 */
  updateSelectedCurrency(currencyCode) {
    const currency = this.currencyData.filter(c => c.code === currencyCode);
    if (currency.length > 0) {
      this.selectedCurrency = currency[0];
      this.rate = this.getRate();
    }
  }

  onOpenPayMethodDialog() {
    let isGroup = false;
    let isDisableAccount = (!(this.paymentData.invoiceId) && !(this.activeRouter.snapshot.params['id']));
    if (!isDisableAccount) {
      if (this.invoiceData.partyTypeId == this.partyType.Group) {
        isGroup = true;
      }
      if (isGroup) {
        isDisableAccount = ((this.invoiceInfoForm.value.groupId ? (
          (this.organizationData[
            this.organizationData.findIndex(x => x.id === this.invoiceInfoForm.value.groupId)].isActive === false))
          : false)
        );
      }
    }
    const data = {
      invoiceId: this.paymentData.invoiceId,
      currency: this.selectedCurrency,
      rate: this.getRate(),
      invoicePayMethod: this.invoiceData.invoicePayMethod,
      totalDue: this.priceModel.total,
      paymentData: this.paymentData,
      isDisableAccount: isDisableAccount,
      groupId: this.invoiceInfoForm.value.groupId,
      isFromHistory: this.isFromHistory,
      isDataEntryMode: this.isDataEntryMode
    };
    this.dialogService
      .openComponentDialog(PayMethodPopupComponent, data)
      .subscribe(result => {
        if (result.isAssignSuccess) {
          this.invoiceData['invoicePayMethod'] = result.invoicePayMethod;
          // call API to save invoice data
          const dataResult = this.invoiceData;
          dataResult.consultationId = this.isFromHistory ? this.filterParam.id : null;
          dataResult.invoiceDetails = this.dataRow;
          this.cashSaleService.saveCashSale(this.invoiceData.id, dataResult, this.cashSaleInfo).subscribe(
            (res1) => {
              if (res1) {
                this.dialogService
                  .openComponentDialog(ConfirmPayMethodPopupComponent, {
                    invoiceNo: this.invoiceData.invoiceNumber, currencyCode: this.selectedCurrency.code, email: this.patientDetail.email
                  }, {
                      width: '370px'
                    })
                  .subscribe(res2 => {
                    if (res2) {
                      // this.isAssignSuccess = true;
                      //   this.onCloseDialog();
                      this.router.navigateByUrl('consultation/waiting-room');
                    }
                  });
              }
            });
        }
      });
  }

  onOpenProductDialog() {
    if (this.isFromHistory === 'edit') {
      return;
    }
    const data = {
      invoiceId: this.invoiceData.id,
      consultationId: this.filterParam.id,
    };
    this.dialogService
      .openComponentDialog(ProductPopupComponent, data)
      .subscribe(result => {
        if (result) {
          if (!this.invoiceData.id && this.invoiceInfoForm.value.groupId && this.organizationDiscountId) {
            result.discountId = this.organizationDiscountId;
          }
          this.updateInvoiceItem(result);
          this.dataRow.push(result);
          this.updatePriceModel();
        }
      });
  }

  onOpenNoteInvoiceDialog() {
    if (this.isFromHistory === 'edit') {
      return;
    }
    const data = {
      invoiceId: this.invoiceData.id,
      consultationId: this.filterParam.id,
      note: this.note
    };
    this.dialogService
      .openComponentDialog(NoteInvoicePopupComponent, data)
      .subscribe(result => {
        if (result) {
          this.note = result['Note'];
          this.invoiceData['note'] = this.note;
        }
      });
  }



  onOpenViewScheduleDialog() {
    if (this.isFromHistory === 'edit') {
      return;
    }
    const data = {
      rate: this.getRate(),
      currency: this.selectedCurrency,
      consultationId: this.filterParam.id,
      invoiceId: this.invoiceData.id
    };
    this.dialogService.openComponentDialog(ViewSchedulePopupComponent, data, { width: '800px' }).subscribe(result => {
      if (result) {
        result.forEach(i => this.updateAddedInvoiceItem(i));
        this.dataRow = this.dataRow.concat(result);
        this.updatePriceModel();
      }
    });
  }

  onRemoveItem(id) {
    this.dialogService
      .openConfirmationDialog({ message: AppMessages.dialog.confirmMessage1 })
      .subscribe(result => {
        if (result) {
          // call API to remove item
          if (this.invoiceData.id) {
            this.cashSaleService.removeItem(this.invoiceData.id, id).subscribe(
              (res) => {
                // remove success then remove item from list
                const index = this.dataRow.findIndex(i => i.id === id);
                if (index >= 0) {
                  this.dataRow.splice(index, 1);
                  this.updatePriceModel();
                }
              }
            );
          } else {
            const index = this.dataRow.findIndex(i => i.id === id);
            if (index >= 0) {
              this.dataRow.splice(index, 1);
              this.updatePriceModel();
            }
          }
        }
      });
  }

  onChangePartyType(event) {
    const type = event.target.value;
    this.isActiveOrganization = false;
    if (type == this.partyType.Individual) {
      ValidationService.removeRequired(
        this.invoiceInfoForm.controls['groupId'],
        []
      );
      this.invoiceData.groupId = null;
      const discountObj = this.getDiscountObject("fbfd27ff-3541-e811-80c3-000d3ab21c9e");
        this.invoiceData.invoiceDetails.forEach(i => {
          {
            this.updateDiscountItem(i, discountObj);
            this.updatePriceModel();
          }
        });
      //
    } else {
      ValidationService.attachRequired(
        this.invoiceInfoForm.controls['groupId'],
        []
      );
      const groupId = this.invoiceInfoForm.value.groupId;
      this.organizationData.forEach(item => {
        if (item.id === groupId) {
          this.isActiveOrganization = item.isActive;
          this.organizationDiscountId = item.value;
        }
      });
    }
  }

  onChangeCurrency(event) {
    this.updateSelectedCurrency(event.target.value);
    this.updateFeeData();
    this.updatePriceModel();
  }

  onChangeDiscount(item, event) {
    item.discountValue = 0;
    const discountObj = this.getDiscountObject(event.target.value);
    item.discountPercent = discountObj.value;
    //this.updateDiscountItem(item, discountObj);
    this.updatePriceModel();
  }
  timeoutKeyupDiscountValueColumn: any = null;
  discountObjDefault = {
    id: "7dea9a85-d908-ea11-b628-10e7c6ab93c2",
    name: "Standard",
    value: "0.00",
  };
  onKeyupTableColumnDiscountValue(item, event) {
    clearTimeout(this.timeoutKeyupDiscountValueColumn);
    this.timeoutKeyupDiscountValueColumn = setTimeout(() => {
      if (event.keyCode != 13) {
        item.discountId = this.discountObjDefault.id;
        item.discountPercent = this.discountObjDefault.value;
        if(item.discountValue > item.price)
        {
          item.discountValue = item.price;
        }
        this.updatePriceModel();
      }
    }, 500);
  }

  updateDiscountItem(item, discountObj) {
    if (discountObj) {
      if(discountObj.value > 0)
      {
        item.rePrice = this.roundPriceNumber(item.price * (1 - discountObj.value) * this.rate);
        item.discountId = discountObj.id;
        item.discountPercent = discountObj.value;
        item.discountValue = 0;
      }
      else
      {
        item.rePrice = this.roundPriceNumber((item.price - item.discountValue) * this.rate);
      }
    }
  }

  onOpenInvoiceReport(item) { }
  /**
	 * update sub total, tax total, total when curency is changed or any item added in the list
	 */
  updatePriceModel() {
    // reset price sub and tax
    this.priceModel.sub = 0;
    this.priceModel.tax = 0;
    this.priceModel.total = 0;
    if (this.isFromHistory === 'edit' || this.paymentData.isPayment) {
      this.priceModel.fee = this.editModeFeeData;
      if (this.invoiceData && this.invoiceData.hasOwnProperty('feeTax')) {
        this.priceModel.tax = this.roundPriceNumber(this.invoiceData['feeTax'] * this.rate);
      }
    } else {
      this.priceModel.tax = this.feeTax;
    }
    // re calculate price
    for (let i = 0; i < this.dataRow.length; i++) {
      this.updateInvoiceItem(this.dataRow[i]);
      this.priceModel.sub += this.dataRow[i].rePrice;
      this.priceModel.tax += this.dataRow[i].reTax;
    }
    this.priceModel.fee = parseFloat(
      this.roundPriceNumber(this.priceModel.fee).toFixed(2)
    );
    this.priceModel.sub = parseFloat(
      this.roundPriceNumber(this.priceModel.sub).toFixed(2)
    );
    this.priceModel.tax = parseFloat(
      this.roundPriceNumber(this.priceModel.tax).toFixed(2)
    );
    this.priceModel.total = parseFloat(
      this.roundPriceNumber(
        this.priceModel.sub + this.priceModel.tax + this.priceModel.fee
      ).toFixed(2)
    );
  }

  onChangeFee(event) {
    const fee = this.feeData.filter(f => f.id.toString() === event.target.value);
    if (fee.length > 0) {
      this.priceModel.fee = this.roundPriceNumber(fee[0].value * this.rate);
      this.invoiceData['feeId'] = fee[0].id;
      this.invoiceData['feePrice'] = fee[0].reValue;
      // update total tax
      this.priceModel.tax = 0;
      this.feeTax = this.roundPriceNumber(fee[0].feeTax * this.rate);
      for (let i = 0; i < this.dataRow.length; i++) {
        this.priceModel.tax += this.dataRow[i].reTax;
      }
      this.priceModel.tax += this.feeTax;
      // update total
      this.priceModel.total = parseFloat(
        this.roundPriceNumber(
          this.priceModel.sub + this.priceModel.tax + this.priceModel.fee
        ).toFixed(2)
      );
      //save consulation fee

    }
  }

  roundPriceNumber(num) {
    return Math.round(num * 100) / 100;
  }

  /**
	 * return rate from defaultCurrencyId to selectedCurrencyId
	 */
  getRate() {
    let rate = 1;
    if (this.invoiceData.hasOwnProperty('defaultCurrencyCode')) {
      const currencyObj = this.invoiceData.currencyRate.filter(
        r => r.code === this.selectedCurrency.code
      );
      if (currencyObj.length > 0) {
        rate = currencyObj[0].rate;
      }
    }
    return rate;
  }

  getCurrencyObject(currencyId) {
    const currency = this.currencyData.filter(c => c.id === currencyId);
    if (currency.length > 0) {
      return currency[0];
    }
    return null;
  }

  getDiscountObject(discountId) {
    const discount = this.discountData.filter(c => c.id === discountId);
    if (discount.length > 0) {
      // discount[0].value = 1 - discount[0].value;
      return discount[0];
    }
    return { value: 0 };
  }

  onSaveInvoice() {
    if (this.invoiceInfoForm.valid) {
      const data = {
        id: this.invoiceData.id,
        orderNo: this.invoiceData.orderNo,
        partyTypeId: this.invoiceInfoForm.value.partyTypeId,
        groupId: this.invoiceInfoForm.value.groupId,
        note: this.note,
        invoiceDetails : this.invoiceData.invoiceDetails,
        feeId : this.invoiceData.feeId,
        feePrice: this.invoiceData.feePrice,
        feeTax: this.invoiceData.feeTax,
        isUpdateInvoiceDate: false
      };
      if (this.isDataEntryMode) {
        data['invoiceDate'] = this.utility.convertDateToLocalString(this.invoiceInfoForm.value.invoiceDate);
        data['isUpdateInvoiceDate'] = true;
      }
      // call API
      if (this.paymentData.isPayment) {

        this.cashSaleService
          .updateAccountPaymentInvoiceInfor(data)
          .subscribe(result => {
            this.setPage({ offset: 0 });
          });
      } else if (this.invoiceData.id) {

        this.cashSaleService
          .saveInvoiceInfo(this.filterParam.id, data)
          .subscribe(result => {
            this.setPage({ offset: 0 });
          });
      } else {
        this.cashSaleInfo = {
          orderNo: this.invoiceData.orderNo,
          partyTypeId: this.invoiceInfoForm.value.partyTypeId,
          groupId: this.invoiceInfoForm.value.groupId,
          invoiceDate: this.invoiceInfoForm.value.invoiceDate,
          invoiceDetails : this.invoiceData.invoiceDetails,
          feeId : this.invoiceData.feeId,
          feePrice: this.invoiceData.feePrice,
          feeTax: this.invoiceData.feeTax,
        };
        if (this.invoiceInfoForm.value.partyTypeId == PartyType.Group) {
          this.updateDiscountOfInvoiceItems(this.organizationDiscountId);
        }
      }
    }
  }

  updateDiscountOfInvoiceItems(discountId) {
    const discountObj = this.getDiscountObject(discountId);
    this.dataRow.forEach(element => {
      if (element['type'] !== this.invoiceItemType.CreditNote) {
        element['discountId'] = discountId;
        this.updateDiscountItem(element, discountObj);
      }
    });
    this.updatePriceModel();
  }

  onChangeOrganization(groupId) {
    this.organizationData.forEach(item => {
      if (item.id === groupId) {
        this.isActiveOrganization = item.isActive;
        this.organizationDiscountId = item.value;
        const discountObj = this.getDiscountObject(this.organizationDiscountId);
        this.dataRow.forEach(element => {
          this.updateDiscountItem(element, discountObj);
          this.updatePriceModel();
        });

        // this.invoiceData.invoiceDetails.forEach(i => {
        //   {
        //     this.updateDiscountItem(i, discountObj);
        //     this.updatePriceModel();
        //   }
        // });
      }
    });
  }

  /**
   * function to show invoice report when user click on view invoice button
   */
  onViewInvoice() {
    const params = {
      [AppConstants.reportParameter.InvoiceNo]: this.invoiceData.invoiceNumber,
      [AppConstants.reportParameter.currency]: this.selectedCurrency.code
    };
    this.sharedService.showReport('Invoice', params);
  }

  onViewPrePaidInvoice(invoiceNumber) {
    const params = {
      [AppConstants.reportParameter.InvoiceNo]: invoiceNumber,
      [AppConstants.reportParameter.currency]: this.selectedCurrency.code
    };
    this.sharedService.showReport('Invoice', params);
  }

  /**
   * function to disable party and group if this is cashsale
   */
  disableParty(isCashSale = false) {
    if (isCashSale) {
      this.invoiceInfoForm.controls['groupId'].disable();
      this.invoiceInfoForm.controls['partyTypeId'].disable();
    }
  }

  /**
   * update isDataEntryMode flag
   * @param dataEntryMode : 0/1
   */
  updateDataEntryMode(dataEntryMode) {
    this.isDataEntryMode = (dataEntryMode === 1) ? true : false;
    this.updateTableLayout();
  }

}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/cash-sale.component.ts